// @ts-check
import React, { ReactElement } from 'react'
import { FieldErrors, RegisterOptions, UseFormRegister } from 'react-hook-form'

const Component = (props: {
  id: string;
  defaultChecked?: boolean;
  label?: ReactElement | string;
  className?: string;
  disabled?: boolean;
  errors?: FieldErrors;
  register: UseFormRegister<any>;
  validations?: RegisterOptions<any>;
}): ReactElement => {
  const {
    id,
    label: checkLabel,
    defaultChecked,
    className,
    disabled,
    errors,
    register,
    validations
  } = props

  const classes = [
    'form-item',
    'form-item--checkbox',
    errors && errors[id]
      ? 'error'
      : ''
  ]
    .filter(Boolean)
    .join(' ')

  let required = false
  if (validations) {
    required = Object.keys(validations).filter(key => key === 'required').length > 0
  }

  return (
    <div
      className={`react-form__form-group ${className || ''}`}
    >
      <div className={classes}>
        <div>
          <input
            type="checkbox"
            id={id}
            className="form-checkbox"
            defaultChecked={defaultChecked}
            {...register(id, validations)}
            disabled={disabled}
          />
          <label
            htmlFor={id}
            className={required ? 'form-required' : ''}
          >
            {checkLabel}
          </label>
        </div>
        {errors && errors[id] &&
          <div className="mt-2 text-sm form-item--error-message">
            {errors[id]?.message}
          </div>
        }
      </div>
    </div>
  )
}

export default Component
